import React, { useState } from 'react';
import { useSearchParams } from 'react-router';
import {
  Badge,
  CondensedHeader,
  ContextMenu,
  ContextMenuItem,
  Layout,
  LayoutItem,
  Well,
} from '@axiom/ui';
import type {
  UserCandidateSearch,
  UserOpportunitySearch,
  UserSearch,
} from '@axiom/validation';

import { SaveFiltersModal } from '../SaveFiltersModal/SaveFiltersModal';
import { DeleteSavedSearchModal } from '../DeleteSavedSearchModal/DeleteSavedSearchModal';

export const SavedSearchesItem = ({
  onRunSearch,
  savedSearch,
  type,
}: {
  onRunSearch: (
    searchFilters:
      UserCandidateSearch['search'] | UserOpportunitySearch['search']
  ) => void;
  savedSearch: UserCandidateSearch | UserOpportunitySearch;
  type: UserSearch['type'];
}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { alertActive, search: filters, id: savedSearchId, name } = savedSearch;

  const [showSaveFiltersModal, setShowSaveFiltersModal] = useState(false);
  const [showDeleteSavedSearchModal, setShowDeleteSavedSearchModal] =
    useState(false);

  return (
    <>
      <Well
        key={`saved-search-well-${savedSearch.id}`}
        name={`saved-search-${name}`}
        background="sky blue"
      >
        <Layout position="middle">
          <LayoutItem horizontalGutter="8px">
            <CondensedHeader name="SAVED_SEARCH_NAME">{name}</CondensedHeader>
          </LayoutItem>
          {alertActive ? (
            <LayoutItem fluid>
              <Badge name="ALERT_BADGE" background="blue">
                ALERT
              </Badge>
            </LayoutItem>
          ) : null}
          <LayoutItem fluid position="right">
            <ContextMenu name="SAVED_SEARCH_CONTEXT_MENU" direction="left">
              <ContextMenuItem
                name="RUN_SEARCH"
                onClick={() => {
                  onRunSearch(filters);
                  searchParams.delete('savedSearchId');
                  searchParams.append('savedSearchId', savedSearchId);
                  setSearchParams(searchParams);
                }}
              >
                Run search
              </ContextMenuItem>
              <ContextMenuItem
                name="EDIT_SEARCH"
                onClick={() => {
                  setShowSaveFiltersModal(true);
                }}
              >
                Edit search
              </ContextMenuItem>
              <ContextMenuItem
                name="DELETE_SEARCH"
                onClick={() => {
                  setShowDeleteSavedSearchModal(true);
                }}
              >
                Delete search
              </ContextMenuItem>
            </ContextMenu>
          </LayoutItem>
        </Layout>
      </Well>
      {showSaveFiltersModal ? (
        <SaveFiltersModal
          onClose={() => {
            setShowSaveFiltersModal(false);
          }}
          savedSearch={savedSearch}
          type={type}
        />
      ) : null}
      {showDeleteSavedSearchModal ? (
        <DeleteSavedSearchModal
          onClose={() => {
            setShowDeleteSavedSearchModal(false);
          }}
          savedSearchId={savedSearch.id}
          type={type}
        />
      ) : null}
    </>
  );
};
